import { RequiredItemTypeEnum } from '@tempus/portal-service-shared';
import { NavigationPath } from '../../../api/constants';
import { PhaseStatus } from '@tempus/order-status-service-shared';
import { FinancialAssistanceStatuses } from 'requisition-service-shared';
import config from '../../../../config';

export const MISSING_ITEM_PATIENT_FIELDS = [
  RequiredItemTypeEnum.SAMPLE_RECEIVED,
  RequiredItemTypeEnum.PAYMENT_RECEIVED,
];

export const MISSING_ITEM_PROVIDER_FIELDS = [
  RequiredItemTypeEnum.PATIENT_MEDICATIONS,
  RequiredItemTypeEnum.ICD_10_CODE,
  RequiredItemTypeEnum.PROVIDER_NPI,
  RequiredItemTypeEnum.PROVIDER_SIGNATURE,
];

export const PAYMENT_LINKS: Record<string, string> = {
  [FinancialAssistanceStatuses.ApprovedNoMoreThan250]: config.paymentLinks.neurology.payment250,
  [FinancialAssistanceStatuses.ApprovedNoMoreThan200]: config.paymentLinks.neurology.payment200,
  [FinancialAssistanceStatuses.ApprovedNoMoreThan100]: config.paymentLinks.neurology.payment100,
};

export enum ActionType {
  PUSH,
  LINK,
}
type PushPathAction = {
  actionType: ActionType.PUSH;
  navigationPath: NavigationPath;
};
type LinkAction = {
  actionType: ActionType.LINK;
  getPatientLink: ({ faStatus }: { faStatus: FinancialAssistanceStatuses | undefined }) => Promise<string>;
};
export type MissingItemConfiguration = {
  buttonText: string;
} & (PushPathAction | LinkAction);

export const PATIENT_MOI_ALERT_CONFIG: Partial<Record<RequiredItemTypeEnum, MissingItemConfiguration>> = {
  [RequiredItemTypeEnum.SAMPLE_RECEIVED]: {
    buttonText: 'Return sample kit',
    actionType: ActionType.PUSH,
    navigationPath: NavigationPath.KIT_RETURN,
  },
  [RequiredItemTypeEnum.PAYMENT_RECEIVED]: {
    buttonText: 'Make a payment',
    actionType: ActionType.LINK,
    getPatientLink: async ({ faStatus }) =>
      faStatus
        ? PAYMENT_LINKS[faStatus as string] ?? config.paymentLinks.neurology.paymentFull
        : config.paymentLinks.neurology.paymentFull,
  },
};

export const COMPLETE_STATUSES = [PhaseStatus.COMPLETE, PhaseStatus.FAILED];
